/**
 * Darf dieser Clip jetzt anfangen zu klingen -- und wie lange?
 *
 * Sascha, 10. September: „VoiceOvers wiederholen sich zum teil am Ende.“ Der
 * Grund lag in der Tonkette: eine Quelle wird mit einem Versatz gestartet und
 * spielt dann bis zum Ende der *Datei*. Ist der Clip länger als die Datei --
 * eine Aufnahme, deren gemeldete Länge nicht stimmt, oder ein Clip, der über
 * das Material hinaus gezogen wurde --, ist die Quelle vorzeitig fertig, der
 * Clip steht aber noch an. Der nächste Durchlauf sah „klingt nicht“, fing
 * wieder an, kam am Ende der Datei heraus und war sofort wieder fertig: die
 * letzten Millisekunden in Schleife, und genau so hört es sich an.
 *
 * Zwei Regeln reichen dagegen:
 *
 * 1. **Was durch ist, bleibt durch.** Eine Stelle, die von selbst zu Ende
 *    gespielt hat, fängt nicht noch einmal an. Erst wer zurückspringt, hört
 *    sie wieder -- deshalb der Abstand: eine Stelle *davor* ist ein neuer
 *    Anlauf, dieselbe Stelle ist eine Wiederholung.
 * 2. **Nur so lange, wie der Clip dauert.** Die Quelle bekommt ihre Länge
 *    mitgegeben und hört von selbst auf. Vorher hing das daran, dass jemand
 *    rechtzeitig `stoppe` ruft -- und wer gerade schneidet, rechnet oder
 *    zeichnet, ruft nicht rechtzeitig.
 */
/** Näher als das am Dateiende lohnt kein Anlauf mehr. */
export const REST_DER_LOHNT = 0.05;
/** So weit muss man zurückspringen, damit es ein neuer Anlauf ist. */
export const ZURUECK_FUER_NEU = 0.25;
export function tonAnfang(lage) {
    const ab = Math.max(0, lage.versatz);
    if (!(lage.laenge > 0) || ab >= lage.laenge - REST_DER_LOHNT)
        return { anfangen: false, grund: 'nichts-mehr-da' };
    if (lage.schonDurch !== null && ab > lage.schonDurch - ZURUECK_FUER_NEU) {
        return { anfangen: false, grund: 'schon-gespielt' };
    }
    const dauer = Math.max(0, Math.min(lage.rest, lage.laenge - ab));
    if (dauer <= 0)
        return { anfangen: false, grund: 'nichts-mehr-da' };
    return { anfangen: true, ab, dauer };
}
//# sourceMappingURL=anfang.js.map